/**
 * Beauty Warehouse — Cart Drawer
 * AJAX cart drawer: open/close, fetch, render, quantity updates.
 * Auto-opens when items are added to the cart.
 */
(function () {
  if (typeof document === 'undefined') return;

  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function formatMoney(cents) {
    var fmt = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : 'R {{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountNoDecimals = Math.round(cents / 100);
    var amountWithComma = amount.replace('.', ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', amountNoDecimals.toLocaleString())
      .replace('{{amount_no_decimals}}', amountNoDecimals)
      .replace('{{amount}}', amount);
  }

  function open() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.setAttribute('open', '');
    document.documentElement.style.overflow = 'hidden';
  }

  function close() {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.removeAttribute('open');
    document.documentElement.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-cart-drawer-trigger]')) {
      e.preventDefault();
      // Drawer is kept in sync via cart:updated. Don't refetch on every open —
      // refetching wipes the app's FREE-chip painter and causes flicker.
      open();
      return;
    }
    if (e.target.closest('[data-cart-drawer-close]')) { close(); return; }
    if (e.target.closest('[data-qty-minus]'))  { changeQty(e, -1); return; }
    if (e.target.closest('[data-qty-plus]'))   { changeQty(e, 1);  return; }
    if (e.target.closest('[data-qty-remove]')) { removeItem(e);    return; }
  });

  document.addEventListener('keydown', function (e) {
    var drawer = getDrawer();
    if (e.key === 'Escape' && drawer && drawer.hasAttribute('open')) close();
  });

  document.addEventListener('cart:updated', function () {
    fetchAndRender().then(open);
  });

  function fetchAndRender() {
    return Promise.all([
      fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }),
      fetch('/?sections=header', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
    ]).then(function (results) {
      var cart = results[0];
      var sections = results[1];
      var html = sections && sections.header ? sections.header : '';
      morphDrawer(html);
      updateBadge(cart.item_count);
      updateShippingBar(cart);
    });
  }

  function morphDrawer(headerHtml) {
    var drawer = getDrawer();
    if (!drawer || !headerHtml) return;
    var doc = new DOMParser().parseFromString(headerHtml, 'text/html');
    var newDrawer = doc.querySelector('[data-cart-drawer]');
    if (!newDrawer) return;
    var newBody = newDrawer.querySelector('.cart-drawer__body, [data-cart-drawer-body]');
    var newFooter = newDrawer.querySelector('.cart-drawer__footer, [data-cart-drawer-footer]');
    var curBody = drawer.querySelector('.cart-drawer__body, [data-cart-drawer-body]');
    var curFooter = drawer.querySelector('.cart-drawer__footer, [data-cart-drawer-footer]');
    if (newBody && curBody) curBody.innerHTML = newBody.innerHTML;
    if (newFooter && curFooter) {
      curFooter.innerHTML = newFooter.innerHTML;
      var newEmpty = newDrawer.querySelector('[data-cart-drawer-empty]');
      var isEmpty = newEmpty && !newEmpty.classList.contains('hidden');
      curFooter.classList.toggle('hidden', !!isEmpty);
    }
    var newCount = newDrawer.querySelector('[data-cart-drawer-count]');
    var curCount = drawer.querySelector('[data-cart-drawer-count]');
    if (newCount && curCount) curCount.textContent = newCount.textContent;

    // Signal so the admin app's bogo-cart.js can re-paint its FREE chip / banner.
    document.dispatchEvent(new CustomEvent('cart:drawer:rendered', { bubbles: true }));
  }

  function changeQty(e, delta) {
    var row = e.target.closest('[data-cart-item]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    var valEl = row.querySelector('[data-qty-value]');
    var current = parseInt(valEl.textContent, 10);
    var newQty = Math.max(0, current + delta);
    updateCart(line, newQty);
  }

  function removeItem(e) {
    var row = e.target.closest('[data-cart-item]');
    if (!row) return;
    var line = parseInt(row.getAttribute('data-line'), 10);
    updateCart(line, 0);
  }

  function updateCart(line, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
    .then(function (r) { return r.json(); })
    .then(function () { return fetchAndRender(); });
  }

  function updateBadge(count) {
    var badges = document.querySelectorAll('[data-cart-count]');
    badges.forEach(function (b) {
      b.textContent = count;
      var badge = b.closest('.header__cart-badge');
      if (badge) badge.classList.toggle('header__cart-badge--hidden', count === 0);
    });
  }

  function updateShippingBar(cart) {
    var bar = document.querySelector('[data-shipping-bar]');
    if (!bar) return;

    var thresholdEl = document.querySelector('[data-shipping-threshold]');
    var thresholdRands = thresholdEl ? parseInt(thresholdEl.getAttribute('data-shipping-threshold'), 10) : 0;
    var threshold = thresholdRands * 100;
    if (!threshold) return;

    var successMsg = bar.getAttribute('data-success-msg') || "You've unlocked free shipping!";
    var shippingLabel = bar.getAttribute('data-shipping-label') || 'free shipping';
    var msgEl = bar.querySelector('[data-shipping-msg]');
    var fillEl = bar.querySelector('[data-shipping-fill]');

    var total = cart.total_price;
    var remaining = Math.max(0, threshold - total);
    var pct = Math.min(100, Math.round(total * 100 / threshold));
    var qualified = total >= threshold;

    bar.classList.toggle('cart-drawer__shipping--done', qualified);
    if (msgEl) {
      msgEl.innerHTML = qualified
        ? successMsg
        : 'Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>' + shippingLabel + '</strong>';
    }
    if (fillEl) fillEl.style.width = pct + '%';
  }

  window.cartDrawer = { open: open, close: close, refresh: fetchAndRender };
})();